var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBriefcase = function SvgBriefcase(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.625H1.5C1.08579 2.625 0.75 2.96079 0.75 3.375V7.125C0.75 7.53921 1.08579 7.875 1.5 7.875H7.5C7.91421 7.875 8.25 7.53921 8.25 7.125V3.375C8.25 2.96079 7.91421 2.625 7.5 2.625Z",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.875V1.875C6 1.67609 5.92098 1.48532 5.78033 1.34467C5.63968 1.20402 5.44891 1.125 5.25 1.125H3.75C3.55109 1.125 3.36032 1.20402 3.21967 1.34467C3.07902 1.48532 3 1.67609 3 1.875V7.875",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBriefcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/briefcase.3b45bbc7.svg";
export { ForwardRef as ReactComponent };